import React, { FunctionComponent } from 'react';
import { map } from 'ramda';

import { NavItems } from 'components/Header/components/Navigation/Navigation.helpers';

import { navItems } from './InternalNav.helpers';
import MenuItem from '../MenuItem';

const renderMenuItems = () => ({ path, label, key }: NavItems) => (
  <MenuItem path={path} label={label} key={key} />
);

const InternalNav: FunctionComponent = () => (
  <> {map(renderMenuItems(), navItems)} </>
);

export default InternalNav;
